<script setup lang="ts">
import { computed } from 'vue'
import logoUrl from '../../../designs/Logo.png'

const props = defineProps<{
  size?: number | string
  alt?: string
}>()

const pixelSize = computed(() => typeof props.size === 'string' ? props.size : `${props.size ?? 24}px`)
</script>

<template>
  <img
    :src="logoUrl"
    :alt="props.alt ?? 'LYT Accounting logo'"
    :style="{ width: pixelSize, height: pixelSize, display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain' }"
  />
</template>
